// extracted by mini-css-extract-plugin
export default {"allCourseBodyWrapper":"allCourseBodyStyle_allCourseBodyWrapper__BfppG"};